import { render, staticRenderFns } from "./GlobalSnackBarDesktop.vue?vue&type=template&id=d606de1e&scoped=true"
import script from "./GlobalSnackBarDesktop.vue?vue&type=script&lang=js"
export * from "./GlobalSnackBarDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d606de1e",
  null
  
)

export default component.exports